<template>
    <div class="wp-block-group is-style-grid-full">
        <div class="wp-block-group__inner-container">
            <div style="height:100px" aria-hidden="true"
                 class="wp-block-spacer wp-block-spacer_top"></div>


            <div id="" class="zb-text-block">

                <h2 class="zb-text lg_txt-title-lg sm_txt-title-md-alt text-align-center has-focus-90-color" style="line-height: 1.2!important;">{{ title }}</h2>

            </div>


            <div style="height:10px" aria-hidden="true" class="wp-block-spacer"></div>


            <div style="height:10px" aria-hidden="true"
                 class="wp-block-spacer zb-hide-on-desktop"></div>


            <!--                                    <div style="height:60px" aria-hidden="true" class="wp-block-spacer"></div>-->


            <div class="zb-expanding-content-container">
                <div class="zb-expanding-content-container__toggle-container">
                    <a class="zb-hide-on-desktop has-focus-90-color zb-expanding-content-container__expand-button zb-expanding-content-container-hide"
                       aria-controls="block_3aea9838f425de54f1a67de6f47ec1eb" aria-expanded="true">
                        See Steps<br>
                        <div class="zb-expanding-content-container-caret-down"></div>
                    </a>
                </div>

                <div id="block_3aea9838f425de54f1a67de6f47ec1eb"
                     class=" zb-expanding-content-container__inner-blocks">

                    <div id="zb_list-image_block_23ee27c5f1e151460adbde3e2341a74e"
                         class="zb-list-image">
                        <ol role="list">

                            <li v-for="(item, key) in list">
                                <span class="zb-list-image--spacer zb-list-image--spacer_without-width" aria-hidden="true">
                                    <span class="zb-text txt-title-md  text-align-right txt-bold has-focus-90-color round-span">{{ key + 1}}.</span>
                                </span>
                                <span class="zb-list-image--text-container">
                                    <h3 class="zb-text txt-title-md  text-align-inherit txt-bold has-focus-90-color">
                                        <span class="mobile-list-number round-span">{{ key + 1 }}</span>
                                        {{ item.title }}
                                    </h3>
                                    <p class="zb-list-image--text-container_text">{{ item.description }}</p>
                                </span>
                            </li>
                        </ol>
                    </div>


                    <div style="height:100px" aria-hidden="true"
                         class="wp-block-spacer zb-hide-on-mobile"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        list: Array,
    }
}
</script>
<style scoped>
@media only screen and (max-width: 767px) {
    .wp-block-spacer_top {
        height: 50px!important;
    }
}

</style>
